import { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '../../../redux/actions';

// แก้ไข มูลค่างาน/เลขที่ PO ตรง ๆ จากการ์ด "ผลการปิดงาน" — แยกจาก modal จบงาน
// (FinishJobDialog) เพราะแค่แก้ไขค่าที่กรอกไปแล้ว ไม่ได้เปลี่ยนสถานะ/แนบเอกสารซ้ำ
export function useJobResultEdit({ opportunity, onChanged, showSnack }) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState('');
  const [poNumber, setPoNumber] = useState('');
  const [saving, setSaving] = useState(false);

  const openDialog = () => {
    setValue(opportunity.value ?? '');
    setPoNumber(opportunity.po_number || '');
    setOpen(true);
  };
  const closeDialog = () => setOpen(false);

  const save = async () => {
    setSaving(true);
    try {
      await dispatch(actions.updateOpportunity({
        id: opportunity.id,
        value: value === '' ? undefined : Number(value),
        poNumber: poNumber || undefined,
      }));
      showSnack('บันทึกสำเร็จ');
      closeDialog();
      onChanged();
    } catch (err) {
      showSnack(err.message || 'บันทึกไม่สำเร็จ', 'error');
    } finally {
      setSaving(false);
    }
  };

  return {
    open, value, setValue, poNumber, setPoNumber, saving, openDialog, closeDialog, save,
  };
}

export default useJobResultEdit;
